export default {"src":"/_next/static/media/fcmb.eca10a5b.svg","height":38,"width":36,"blurWidth":0,"blurHeight":0};